import '../../httpservices/core/ajax.httpservice.core';

class PortalPatientEdHttpService {
    GetInitData() {
        return $.get('Patient/PatientEducation/GetInitData');
    }

    GetCaregiverFaqPageInit() {
        return $.get('Patient/PatientEducation/GetCaregiverFaqPageInit');
    }
}

export const PortalPatientEdHttpSvc = new PortalPatientEdHttpService();